import { api } from '@/f1/service';
import draggable from 'vuedraggable'
import _ from 'lodash'

//restful api
//import { wmds as ws } from '@/f1/service/api'

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';


const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : "", sv : "", skt : ""
})

const default_page = () => ({
  roots : undefined, subs : [], drag_list : [], list : [], range : 30, end : 0,
})

export default {
  watch : {
    snapshot() {
      if(this.snapshot.length >= 10) {
        this.$toastr.w(`${_i18n_data._i18n_warning.snapshot[this.i18n]}`)
      }
    }
  },
  components: { draggable },
  data: () => ({
    so : default_opt(),
    model : {},
    page : default_page(),
    snapshot : [],
    level : '9',
    request : false
  }),
  computed: {
    fields() { return _i18n_data.i18n_fields[this.i18n]; },
    page_set() {
      let rv = [];
      _.forEach(this.model.page_data, l => _.forEach(l, r => rv.push(r)))
      return rv;
    },
    page_sub() { return _.groupBy(this.page_set, r => r[2]); },
    urlParser() {
      let rs = [];
      let roots = _.filter(this.page_set, p => p[0] == 0);
      let subs = this.page_sub;
      const builder = (r) => {
        // level 은 기본값은 뎁스 최대값이다
        // let url =  [{ url : r[8], hash : r[3], dept : r[0], level : r.level }]
        let url =  [{ url : r[8], hash : r[3], dept : this.level, level : r.level }]
        _.forEach(subs[r[1]], s => url = url.concat(builder(s))); // r[1] == this
        return url;
      }

      _.forEach(roots, r => rs = rs.concat(builder(r)));

      if(!rs.length) {
        let mains = this.page_set;
        // rs = _.map(mains, r => { return { url : r[8], hash : r[3], dept : r[0], level : r.level }});
        rs = _.map(mains, r => { return { url : r[8], hash : r[3], dept : r[0], level : r.level }});
      }
      return rs;
    },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; }
  },
  methods: {
    clear() { this.clear_forgery(); this.model = {}; this.page = default_page(); },
    clear_forgery() { this.snapshot = [], this.model.is_alive = false; },
    detail() { this.$router.push(`/wmds/site/${this.model.id}`); },
    remove(i) { this.snapshot.splice(i, 1) },
    scan_status(status){ this.model.is_alive = status; return this.save(); },
    async save() {
      try {
        // convert
        let hashs = [];
        let snapshotResult = _.compact(this.snapshot.map(r => {
          // if(location.hostname == "localhost") { console.log([(r.url || '').trim(), r.level || this.level, r.hash]) }
          // if(hashs.indexOf(r.hash) > -1) { console.log("remove duplicate", r.hash, (r.url || '').trim()); this.$toastr.w("remove duplicate", r.url); return; }
          // else { hashs.push(r.hash); return [(r.url || '').trim(), r.dept, r.hash] }
          if(hashs.indexOf(r.hash) > -1) { console.log("remove duplicate", r.hash, (r.url || '').trim()); this.$toastr.w(`${_i18n_data._i18n_warning.hash_remove[this.i18n]}`, r.url); return; }
          else { hashs.push(r.hash); return [(r.url || '').trim(), this.level, r.hash] }
        }))
        // console.log('this.snapshot', this.snapshot, '여기서 다른가?', snapshotResult)
        // this.snapshot = snapshotResult;
        let data = this.model.integrity_id
          ? { snapshot : snapshotResult, group_id : this.model.group_id, id : this.model.integrity_id, site_id : this.model.id, is_alive : this.model.is_alive  }
          : { snapshot : snapshotResult, group_id : this.model.group_id, site_id : this.model.id, is_alive : this.model.is_alive };

        let rs = await api.wmds.WMDS_Call('forgery', this.model.integrity_id ? 'update' : 'insert', data)
        
        // let check_id = this.model.integrity_id ? `${await ws.forgery.update(data)}` : `${await ws.forgery.insert(data)}`
        // let rs = check_id

        if(rs.error) {
          // this.$toastr.e("faild", "data saving failed")
          this.$toastr.e(`${_i18n_data._i18n_error.data_failed[this.i18n]}`)
        } else {
          this.$toastr.s(`${i18n_data._i18n_success.done[this.i18n]}`, this.model.integrity_id ? `${i18n_data._i18n_success.updated[this.i18n]}` : `${i18n_data._i18n_success.saved[this.i18n]}`);
          if(!this.model.integrity_id) { this.model.id = rs.body.id; }
          this.model.is_alive = true
        }

      } catch(e) { console.log(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.save_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) }
    },
    scroll_page() {
      let div = this.$refs.page_list;
      if(this.page.end >= this.model.page_count) { return; }
      if(div.clientHeight + div.scrollTop < div.scrollHeight) { return; }
      let add = _.slice(this.urlParser, this.page.end, this.page.end + this.page.range);
      console.log('load slice', this.page.end, add.length );
      this.page.end += add.length;
      if(add.length) { this.page.list = _.concat(this.page.list, add) }
    },
    reset() { this.so = default_opt(); this.$refs._list.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        target : 'site', cmd : 'list',
        body : { sort : [], or : [], and : [{ name : 'is_del', value : false, op : '='}] },
        offset : (this.so.currentPage - 1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim()) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return api.wmds.WMDS(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) );
      //return ws.site.list(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    async integrity_select() {
      let rs = await api.wmds.WMDS_Call('forgery', 'detail', { type : 'wmds', site_id : this.model.id });
      //let rs = await ws.forgery.detail({ type : 'wmds', site_id : this.model.id });
      if(rs.error) { return this.$toastr.w(`${_i18n_data._i18n_warning.integrity_select[this.i18n]}`) }
      // [url, level, hash]
      this.model.integrity_id = rs.body.id;
      this.model.last_updated = rs.body.updated_at
      this.snapshot = [];
      (rs.body.snapshot || []).forEach(r => this.snapshot.push({ url : r[0], level : r[1], dept : r[1], hash : r[2] }))
    },
    async result_select(m) {
      this.request = true
      // TODO : 로딩 부분 넣어야 함
      this.model = m;
      try {
        let so = {
          target : 'result', cmd : 'list',
          body : { sort : [{ name : "id", op : "desc"}], and : [
            { name : "site_id", value : Number(this.model.id), op : "="},
            { name : "finished_at", value : Number(this.model.id), op : "is not null"}
          ] },
          offset : 0, limit : 1
        }
        let result_list = await api.wmds.WMDS(so)
        if(result_list.error) { return this.$toastr.e(`${_i18n_data._i18n_error.load_failed[this.i18n]}`) }
        if(result_list.body == null) { this.request = false; return }
        let result_id = result_list.body[0].id;
        let result = await api.wmds.WMDS({ limit : 1, target : 'result', cmd : 'detail', body : { id : result_id } })
        //let result = await ws.result.detail({ limit : 1, body : { id : result_id } })
        if(result.error || result.body == null) { this.request = false; this.page = default_page(); return this.$toastr.e(`${_i18n_data._i18n_error.failed[this.i18n]}`, `${_i18n_data._i18n_error.load_failed[this.i18n]}`); }
        result = result.body;
        if((result.page_count || 0) < 1) { this.request = false; this.page = default_page(); return this.$toastr.e(`${_i18n_data._i18n_error.failed[this.i18n]}`, `${_i18n_data._i18n_error.result[this.i18n]}`) }

        this.page.list = [];
        this.snapshot = [];
        this.page.end = 0;
        this.model = Object.assign(this.model, { page_count : result.page_count, page_data : result.page_data, thumbnail : result.thumbnail, last_done : result.created_at })
        this.model.page_count = this.urlParser.length
        let add = _.slice(this.urlParser, 0, this.page.range * 2);
        this.page.end += add.length;
        this.page.list = _.concat(this.page.list, add)

        this.integrity_select()
        this.$toastr.i(`${i18n_data._i18n_success.done[this.i18n]}`, `${_i18n_data._i18n_info.recently[this.i18n]}`)
        this.request = false
      } catch(e) { this.request = false; this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) }
    },
  },
  created: function() {   console.log('site.list.vue', 'created'); },
  destroyed: function() { console.log('site.list.vue', 'destroyed'); },
  mounted: function() { console.log('site.list.vue', 'mounted'); },
}
